import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { ChartsModule } from 'ng2-charts';

import { EnhancedTableModule } from '../../../modules/enhanced-table';
import {
  ActiveSessionsCategoriesComponent,
} from './components/active-sessions-categories/active-sessions-categories.component';
import { ActiveSessionsComponent } from './components/active-sessions/active-sessions.component';
import { ActiveUsersComponent } from './components/active-users/active-users.component';
import { AggregatedComponent } from './components/aggregated/aggregated.component';
import { DashboardPageComponent } from './components/dashboard-page/dashboard-page.component';
import { DashboardService } from './dashboard.service';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild([
      {path: '', component: DashboardPageComponent}
    ]),
    TranslocoModule,

    ChartsModule,

    MatCardModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,

    EnhancedTableModule
  ],
  declarations: [
    DashboardPageComponent,
    AggregatedComponent,
    ActiveSessionsComponent,
    ActiveUsersComponent,
    ActiveSessionsCategoriesComponent
  ],
  providers: [DashboardService]
})
export class DashboardModule { }
